import { useParams } from "react-router-dom"
import useGetDeviceDetail from "@/hooks/api/use-get-device-detail"
import DeviceDetailHeader from "@/components/DeviceDetailHeader"
import DeviceInformation from "@/components/DeviceInformation"
import MeterReading from "@/components/MeterReading"
import ConsumptionData from "@/components/ConsumptionData"
import Alarms from "@/components/Alarms"
import { LoadingSpinner } from "@/components/ui/loading-spinner"

export default function DeviceDetailPage() {
  const { deviceId, councilId } = useParams()
  const { data: device, isLoading } = useGetDeviceDetail(councilId ?? "", deviceId ?? "")

  if (isLoading) {
    return <LoadingSpinner />
  }

  if (!device) {
    return <div>Device not found</div>
  }

  const dev = device as Record<string, unknown>

  return (
    <div className="space-y-6">
      <DeviceDetailHeader councilId={councilId ?? ""} deviceId={deviceId ?? ""} />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <DeviceInformation device={device} />
        <MeterReading
          current={Number(dev["lastIndex"]) || 0}
          lastRead={String(dev["lastReading"] ?? "")}
          unit={String(dev["indexUnit"] ?? "")}
        />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <ConsumptionData
          deviceId={Number(dev["id"]) || 0}
          councilId={councilId ?? ""}
          unavailableReason={dev["consumptionDataUnavailableReason"]}
        />

        <Alarms alarms={(dev["alarms"] as import("@/gen/api").Alarm[]) ?? []} />
      </div>
    </div>
  )
}
